import { useEffect, useCallback } from "react";
import { amplitudeOptOut } from "./useAmplitude";

const noop = () => null;

const isAnalyticsAccepted = (consentConfig) =>
    consentConfig?.ANALYTICS === "ACCEPT";

export const hasOsano = () => !!window?.Osano;

export const isOsanoAnalyticsAllowed = () => {
    if (!hasOsano()) {
        return true;
    }

    return isAnalyticsAccepted(window.Osano.cm.getConsent());
};

export const showOsanoDrawer = () => hasOsano() && window.Osano.cm.showDrawer();

export const useOsano = () => {
    const onConfigUpdated = useCallback((consentConfig) => {
        const canDoAnalytics = isAnalyticsAccepted(consentConfig);
        amplitudeOptOut(!canDoAnalytics);
    }, []);

    useEffect(() => {
        if (!hasOsano()) {
            return noop;
        }

        window.Osano.cm.addEventListener("osano-cm-consent-saved", onConfigUpdated);

        return () => {
            window.Osano.cm.removeEventListener(
                "osano-cm-consent-saved",
                onConfigUpdated
            );
        };
    }, [onConfigUpdated]);

    return {
        isOsanoAnalyticsAllowed: isOsanoAnalyticsAllowed()
    }
};
